/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2021
 * @format
 * @flow
 */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ErrorOrder.module.css';
import strings from '../../../../globalization';

const colors = ['white', 'gray'];

const ErrorOrder = props => {
  const { closePopup, viewErrorOrders, acknowledgeErrorOrder } = props;
  const [blinkValue, setBlinkValue] = useState({
    backgoundColor: 'white',
    counter: 0,
  });
  const intervalRef = useRef(null);

  useEffect(() => {
    startBlinking();
    return () => {
      clearInterval(intervalRef.current);
    }
  }, []);

  const startBlinking = () => {
    intervalRef.current = setInterval(() => {
      setBlinkValue((blink) => ({
        backgoundColor: colors[(blink.counter + 1) % colors.length],
        counter: (blink.counter + 1) % colors.length,
      }));
    }, 1000);
  };

  const onClose = () => {
    closePopup && closePopup();
    acknowledgeErrorOrder && acknowledgeErrorOrder();
  };

  return (
    <div className={styles.container} style={{ backgroundColor: blinkValue.backgoundColor }}>
      <span className={styles.closeIcon} onClick={onClose}>X</span>
      <div className={styles.msgText}>!!!{strings.orderErrors.toUpperCase()}!!!</div>
      <button className={styles.btn} onClick={viewErrorOrders}>
        <span className={styles.btnText}>{strings.viewErrorOrders.toUpperCase()}</span>
      </button>
    </div>
  )
};

export default ErrorOrder;

ErrorOrder.propTypes = {
  closePopup: PropTypes.func,
  viewErrorOrders: PropTypes.func,
  acknowledgeErrorOrder: PropTypes.func,
};

ErrorOrder.defaultProps = {
  closePopup: () => { },
  viewErrorOrders: () => { },
  acknowledgeErrorOrder: () => { },
};
